import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LOCALE_KEY = 'app_locale';
  private translate = inject(TranslateService);
  private localStorage = inject(LocalStorageService);

  // Expose signal for reactive UI updates
  public currentLocale = signal<string>('en');

  init(): void {
    const savedLocale = this.localStorage.getString(this.LOCALE_KEY) || 'en';
    
    // Safely assign fallback methods to defend against varying typings
    const service = this.translate as any;
    if (typeof service.setDefaultLang === 'function') {
      service.setDefaultLang('en');
    } else if (typeof service.setDefault === 'function') {
      service.setDefault('en');
    }

    this.setLanguage(savedLocale);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    this.currentLocale.set(lang);
    this.localStorage.setString(this.LOCALE_KEY, lang);
  }
}